<script setup lang="ts">
import {useVersion} from "@/composables/version";
import axios from "axios";
import {route} from "ziggy-js";
import {router} from "@inertiajs/vue3";

const {version} = useVersion()

const resetOnboarding = () => {
    axios.post(route('onboarding.completed'), {
        onboarding_completed: false,
    }).then(() => {
        window.location.reload();
    })
}
</script>

<template>
    <v-menu
        location="top start"
        z-index="10000"
    >
        <template #activator="{ props: bind }">
            <v-btn
                variant="text"
                color="base"
                class="text-body-2 text-none"
                v-bind="bind"
            >
                <v-icon class="mr-1">
                    mdi-help-circle-outline
                </v-icon>
                Help
            </v-btn>
        </template>
        <v-list
            rounded="lg"
            border="sm"
            elevation="0"
            class="bg-background pa-1"
            width="250"
        >
            <v-list-item
                class="text-body-2 pl-2"
                link
                density="compact"
                @click="resetOnboarding"
            >
                Welcome Tour
            </v-list-item>
            <v-list-item
                class="text-body-2 pl-2"
                link
                href="mailto:capacity-framework-support@sib.swiss?subject=Capacity%20Framework%20Support"
                density="compact"
            >
                Support
            </v-list-item>
            <v-list-item
                class="text-body-2 pl-2"
                link
                href="https://clinbiokb.sib.swiss/s/capacity-framework"
                target="_blank"
                density="compact"
            >
                Documentation
            </v-list-item>
            <v-list-item
                class="text-body-2 pl-2"
                link
                density="compact"
                href="https://spdx.org/licenses/MIT.html"
                target="_blank"
            >
                License
            </v-list-item>
            <v-list-item
                class="text-body-2 pl-2"
                link
                density="compact"
                @click="router.get(route('about'))"
            >
                About
            </v-list-item>
            <v-list-item
                class="text-body-2 pl-2"
                link
                density="compact"
                href="https://sib.swiss"
                target="_blank"
            >
                About SIB
            </v-list-item>
            <v-list-item
                class="text-body-2 pl-2"
                link
                density="compact"
                @click.stop
            >
                Version {{ version }}
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<style scoped>

</style>
